import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'header',
    label: 'Header',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
